import DepreciationEquipment from './component'

export default DepreciationEquipment
